export class MaintenanceMessageDto {
    title: string; // Title of the maintenance message
    messageBody: string; // Body of the maintenance message
    createdAt: Date; // Timestamp for when the message was created
    isActive: boolean; // Indicates if the message is currently active
    urlMoreInfo : string;
  
    constructor() {
      this.createdAt = new Date(); // Default to current UTC time
      this.isActive = true; // Default to active
    }
  }